// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"22":"2591512b","118":"11d6855e","327":"c1917735","358":"e3e1552f","431":"8caa4c1e","473":"85511219","518":"38a989e8","761":"84a5a926","765":"440cad2d","779":"e5dd8dd5"}[chunkId] + ".js";
};